import {twJoin} from 'tailwind-merge'

import {noop} from '@sdox/utils'

import {Button} from '../Button'
import {Media} from '../Media'

import type {MediaProps} from '../Media'

export interface DataSheetItemProps {
  title: string
  mediaProps?: MediaProps
  description?: string
  additional?: string
  buttonLabel?: string
  onButtonClick?: () => void
}

export const DataSheetItem = ({
  title,
  mediaProps,
  description,
  additional,
  buttonLabel,
  onButtonClick = noop,
}: DataSheetItemProps) => (
  <div className={'@container/block'}>
    <div
      className={twJoin(
        'flex flex-col rounded-radius-interactive-tile',
        'border-1 border-interactive-outline-default-default bg-interactive-surface-filled-inversed-default',
        'pb-spacing-40',
      )}
    >
      <Media
        {...mediaProps}
        aspectRatio={'16/10'}
      />
      <div className={'flex flex-col items-start gap-spacing-8 p-spacing-36 pb-spacing-0 text-interactive-glyph-default-primary'}>
        <h4 className={'@[664]:text-h4 line-clamp-6 text-h4-xs'}>{title}</h4>
        <p className={'line-clamp-10 text-p2'}>{description}</p>
        <p className={'line-clamp-20 text-p3'}>{additional}</p>
      </div>
      <div className={'flex flex-col items-start p-spacing-36 pt-spacing-40'}>
        <Button
          variant={'outline'}
          onClick={onButtonClick}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  </div>
)